import { render, staticRenderFns } from "./items-history.vue?vue&type=template&id=6d96d6b7&scoped=true"
import script from "./items-history.vue?vue&type=script&lang=js"
export * from "./items-history.vue?vue&type=script&lang=js"
import style0 from "./items-history.vue?vue&type=style&index=0&id=6d96d6b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d96d6b7",
  null
  
)

export default component.exports